<template>
  <section v-if="enabled" id="zoombar" class="buttons has-addons">
    <button v-if="geolocationEnabled" type="button" class="zoom-out button is-dark has-background-black-bis" @click="locate">
      <b-icon :icon="geolocation" type="" size="is-small"></b-icon>
    </button>
    <button type="button" class="zoom-out button is-dark has-background-black-bis" @click="zoomOut">
      <b-icon icon="minus" type="" size=""></b-icon>
    </button>
    <button type="button" class="zoom-in button is-dark has-background-black-bis" @click="zoomIn">
      <b-icon icon="plus" type="" size=""></b-icon>
    </button>
  </section>
</template>

<script>

import map from 'util/MapEngine'

export default {
  data () {
    return {
      enabled: (this.$conf.zoombar && this.$conf.zoombar.enabled),
      geolocationEnabled: (this.$conf.geolocation && this.$conf.geolocation.enabled),
      isActive: false
    }
  },
  computed: {
    geolocation: function () { return this.isActive ? 'crosshairs-gps' : 'crosshairs' }
  },
  methods: {
    zoomIn: function () {
      this.$map.zoomIn()
    },
    zoomOut: function () {
      this.$map.zoomOut()
    },
    locate: function () {
      this.isActive = !this.isActive
    }
  }
}

</script>

<style lang="stylus" scoped>

#zoombar
  position: absolute
  right: 36px
  top: 10px
  z-index: 1002
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11)
  transform: rotate(-90deg)
  transform-origin: top right
  margin: 0
  button
    margin: 0
    border-right: 1px solid #7a7a7a
    &:last-child
      border-bottom-right-radius: 0
      border-right: none
    &:first-child
      border-bottom-left-radius: 0
    span
      transform: rotate(90deg)



</style>
